import type {ReactElement} from 'react';
import Divider from '@Components/divider';
import type {FieldSpacerProps} from './field-spacer.types';
import {FIELD_SPACER_HEIGHT_PX} from './field-spacer.types';
import styles from './field-spacer.module.scss';

export function FieldSpacer({width}: FieldSpacerProps): ReactElement {
  return <Divider width={width} height={FIELD_SPACER_HEIGHT_PX} additionalClasses={styles.divider} />;
}
